<template>
  <div v-show="show">
    <el-form :inline="true" class="demo-form-inline"></el-form>
    <el-table :data="tabledata" border style="width: 95%; margin-top: 50px; margin-left: 20px" height="450" :empty-text="$t('general.empty_data')">
      <el-table-column fixed prop="member" :label="$t('pensionadminde.memberid')" width="120" align="center">
      </el-table-column>
      <el-table-column prop="name" :label="$t('pensionadminde.name')" width="130" align="center"></el-table-column>
      <el-table-column prop="total14" :label="$t('pensionbasicde.grandtotal')" width="130" align="center">
      </el-table-column>
      <el-table-column prop="average" :label="$t('pensionbasicde.average')" width="130" align="center">
      </el-table-column>
      <el-table-column prop="adjustedaverage" :label="$t('pensionbasicde.adjustedaverage')" width="140" align="center">
      </el-table-column>
      <el-table-column prop="note" :label="$t('pensionadminde.notice')" align="center"></el-table-column>
      <el-table-column fixed="right" :label="$t('general.operation')" width="220" align="center">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="info" size="mini">{{$t('pensionadminde.detail')}}
          </el-button>
          <el-button @click="handleClick2(scope.row)" type="primary" size="mini">{{$t('pensionadminde.edit')}}
          </el-button>
          <el-button @click="printPensionAccount(scope.row)" type="success" size="mini">
            {{$t('pensionadminde.print')}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Details -->

    <el-dialog :title="$t('pensionadminde.detail')" :visible.sync="dialoglook" width="90%">
      <el-form ref="form4" :model="form4" label-width="80px" :label-position="labelPosition">
        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.memberid')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="4">{{form4.member}}</el-col>

          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.name')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="4">{{form4.name}}</el-col>

          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.notice')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="8">{{form4.note}}</el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip>
              <el-button>{{$t('pensionbasicde.april')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">{{form4.days4}}</el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">{{form4.currency4}}</el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">{{form4.stocks4}}</el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">{{form4.total4}}</el-col>
          <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
          <el-col :span="3">{{form4.total14}}</el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip>
              <el-button>{{$t('pensionbasicde.may')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">{{form4.days5}}</el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">{{form4.currency5}}</el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">{{form4.stocks5}}</el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">{{form4.total5}}</el-col>
          <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
          <el-col :span="3">{{form4.average}}</el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip>
              <el-button>{{$t('pensionbasicde.june')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">{{form4.days6}}</el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">{{form4.currency6}}</el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">{{form4.stocks6}}</el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">{{form4.total6}}</el-col>
          <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
          <el-col :span="3">{{form4.adjustedaverage}}</el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialoglook = false">{{$t('pensionbasicde.cancle')}}</el-button>
        <el-button type="primary" @click="dialoglook = false">{{$t('pensionbasicde.confirm')}}</el-button>
      </div>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :visible.sync="dialogedit" width="90%">
      <el-form ref="form4" :model="form4" label-width="80px" :label-position="labelPosition">
        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.memberid')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="4">{{form4.member}}</el-col>

          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.name')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="4">{{form4.name}}</el-col>

          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.notice')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="10">
            <el-input v-model="form4.note"></el-input>
          </el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" content placement="top-start">
              <el-button>{{$t('pensionbasicde.april')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">
            <el-select v-model="form4.days4" placeholder>
              <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.currency4"></el-input>
          </el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.stocks4" @blur="add44"></el-input>
          </el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">
            <el-input v-model="form4.total4" readonly="readonly"></el-input>
          </el-col>
          <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
          <el-col :span="3">
            <el-input v-model="form4.total14" readonly="readonly"></el-input>
          </el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" content placement="top-start">
              <el-button>{{$t('pensionbasicde.may')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">
            <el-select v-model="form4.days5" placeholder>
              <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.currency5"></el-input>
          </el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.stocks5" @blur="add54"></el-input>
          </el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">
            <el-input v-model="form4.total5" readonly="readonly"></el-input>
          </el-col>
          <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
          <el-col :span="3">
            <el-input v-model="form4.average" readonly="readonly"></el-input>
          </el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" content placement="top-start">
              <el-button>{{$t('pensionbasicde.june')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">
            <el-select v-model="form4.days6" placeholder>
              <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.currency6"></el-input>
          </el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.stocks6" @blur="add64"></el-input>
          </el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">
            <el-input v-model="form4.total6" readonly="readonly"></el-input>
          </el-col>
          <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
          <el-col :span="3">
            <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
          </el-col>
        </el-form-item>

        <hr />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogedit = false">{{$t('general.cancel')}}</el-button>
        <el-button type="primary" @click="updatePensionAccount">{{$t('general.confirm')}}</el-button>
      </div>
    </el-dialog>

    <!-- Add -->
    <el-dialog :title="$t('general.add')" :visible.sync="dialogadd" width="90%">
      <el-form ref="form4" :model="form4" label-width="80px" :label-position="labelPosition">
        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.memberid')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="4">{{form4.member}}</el-col>

          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.name')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="4">{{form4.name}}</el-col>

          <el-col :span="1">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <el-button>{{$t('pensionadminde.notice')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="10">
            <el-input v-model="form4.note"></el-input>
          </el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" content placement="top-start">
              <el-button>{{$t('pensionbasicde.april')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">
            <el-select v-model="form4.days4" placeholder>
              <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.currency4"></el-input>
          </el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.stocks4" @blur="add44"></el-input>
          </el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">
            <el-input v-model="form4.total4" readonly="readonly"></el-input>
          </el-col>
          <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
          <el-col :span="3">
            <el-input v-model="form4.total14" readonly="readonly"></el-input>
          </el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" content placement="top-start">
              <el-button>{{$t('pensionbasicde.may')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">
            <el-select v-model="form4.days5" placeholder>
              <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.currency5"></el-input>
          </el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.stocks5" @blur="add54"></el-input>
          </el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">
            <el-input v-model="form4.total5" readonly="readonly"></el-input>
          </el-col>
          <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
          <el-col :span="3">
            <el-input v-model="form4.average" readonly="readonly"></el-input>
          </el-col>
        </el-form-item>

        <hr />

        <el-form-item>
          <el-col :span="1">
            <el-tooltip class="item" effect="dark" content placement="top-start">
              <el-button>{{$t('pensionbasicde.june')}}</el-button>
            </el-tooltip>
          </el-col>
          <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
          <el-col :span="2">
            <el-select v-model="form4.days6" placeholder>
              <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.currency6"></el-input>
          </el-col>
          <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
          <el-col :span="2">
            <el-input v-model.number="form4.stocks6" @blur="add64"></el-input>
          </el-col>
          <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
          <el-col :span="3">
            <el-input v-model="form4.total6" readonly="readonly"></el-input>
          </el-col>
          <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
          <el-col :span="3">
            <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
          </el-col>
        </el-form-item>

        <hr />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogadd = false">{{$t('general.cancel')}}</el-button>
        <el-button type="primary" @click="addPensionAccount">{{$t('general.confirm')}}</el-button>
      </div>
    </el-dialog>

  </div>
</template>



<script>
export default {
  data() {
    return {
      show: true,
      loading: false,
      labelPosition: "left",
      tabledata: [],
      dialoglook: false,
      search: "",
      dialogedit: false,
      formLabelWidth: "120px",

      form4: {
        member: "",
        name: "",
        days4: "",
        days5: "",
        days6: "",
        currency4: "",
        currency5: "",
        currency6: "",
        stocks4: "",
        stocks5: "",
        stocks6: "",
        total4: "",
        total5: "",
        total6: "",
        total14: "",
        average: "",
        adjustedaverage: "",
        note: ""
      },
      days: [{
        codeid: "0",
        label: "0日"
      },
      {
        codeid: "1",
        label: "1日"
      },
      {
        codeid: "2",
        label: "2日"
      },
      {
        codeid: "3",
        label: "3日"
      },
      {
        codeid: "4",
        label: "4日"
      },
      {
        codeid: "5",
        label: "5日"
      },
      {
        codeid: "6",
        label: "6日"
      },
      {
        codeid: "7",
        label: "7日"
      },
      {
        codeid: "8",
        label: "8日"
      },
      {
        codeid: "9",
        label: "9日"
      },
      {
        codeid: "10",
        label: "10日"
      },
      {
        codeid: "11",
        label: "11日"
      },
      {
        codeid: "12",
        label: "12日"
      },
      {
        codeid: "13",
        label: "13日"
      },
      {
        codeid: "14",
        label: "14日"
      },
      {
        codeid: "15",
        label: "15日"
      },
      {
        codeid: "16",
        label: "16日"
      },
      {
        codeid: "17",
        label: "17日"
      },
      {
        codeid: "18",
        label: "18日"
      },
      {
        codeid: "19",
        label: "19日"
      },
      {
        codeid: "20",
        label: "20日"
      },
      {
        codeid: "21",
        label: "21日"
      },
      {
        codeid: "22",
        label: "22日"
      },
      {
        codeid: "23",
        label: "23日"
      },
      {
        codeid: "24",
        label: "24日"
      },
      {
        codeid: "25",
        label: "25日"
      },
      {
        codeid: "26",
        label: "26日"
      },
      {
        codeid: "27",
        label: "27日"
      },
      {
        codeid: "28",
        label: "28日"
      },
      {
        codeid: "29",
        label: "29日"
      },
      {
        codeid: "30",
        label: "30日"
      },
      {
        codeid: "31",
        label: "31日"
      }
      ]
    };
  },

  methods: {
    handleClick(row) {
      this.dialoglook = true;
      this.form4.member = row.member;
      this.form4.name = row.name;
      this.form4.days4 = row.days4;
      this.form4.days5 = row.days5;
      this.form4.days6 = row.days6;
      this.form4.currency4 = row.currency4;
      this.form4.currency5 = row.currency5;
      this.form4.currency6 = row.currency6;
      this.form4.stocks4 = row.stocks4;
      this.form4.stocks5 = row.stocks5;
      this.form4.stocks6 = row.stocks6;
      this.form4.total4 = row.total4;
      this.form4.total5 = row.total5;
      this.form4.total6 = row.total6;
      this.form4.total14 = row.total14;
      this.form4.average = row.average;
      this.form4.adjustedaverage = row.adjustedaverage;
      this.form4.note = row.note;
    },
    handleClick2(row) {
      this.dialogedit = true;
      this.form4.member = row.member;
      this.form4.name = row.name;
      this.form4.days4 = row.days4;
      this.form4.days5 = row.days5;
      this.form4.days6 = row.days6;
      this.form4.currency4 = row.currency4;
      this.form4.currency5 = row.currency5;
      this.form4.currency6 = row.currency6;
      this.form4.stocks4 = row.stocks4;
      this.form4.stocks5 = row.stocks5;
      this.form4.stocks6 = row.stocks6;
      this.form4.total4 = row.total4;
      this.form4.total5 = row.total5;
      this.form4.total6 = row.total6;
      this.form4.total14 = row.total14;
      this.form4.average = row.average;
      this.form4.adjustedaverage = row.adjustedaverage;
      this.form4.note = row.note;
    },

    add44() {
      this.form4.total4 =
        parseInt(this.form4.currency4) + parseInt(this.form4.stocks4);
    },

    add54() {
      this.form4.total5 =
        parseInt(this.form4.currency5) + parseInt(this.form4.stocks5);
    },
    add64() {
      this.form4.total6 =
        parseInt(this.form4.currency6) + parseInt(this.form4.stocks6);
    },

    updatePensionAccount() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/updatePensionAccount",
        data: postData
      })
        .then(response => {
          this.dialogedit = false;
          this.axios
            .post("/listpensionaccount")
            .then(response => {
              this.tabledata = response.data;
              console.log(this.tabledata);
            })
            .catch(error => {
              console.log(error);
            });

          this.$message({
            type: "success",
            message: this.$t("general.edit_completed")
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    findPensionAccount() {
      let postData = this.qs.stringify({
        search: this.search
      });

      this.axios({
        method: "post",
        url: "/findpensionaccount",
        data: postData
      })
        .then(response => {
          this.tabledata = response.data;
          console.log(this.tabledata);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    printPensionAccount(row) {
      let postData = this.qs.stringify({
        name: row.name,
        days4: row.days5,
        days5: row.days5,
        days6: row.days6,
        currency4: row.currency4,
        currency5: row.currency5,
        currency6: row.currency6,
        stocks4: row.stocks4,
        stocks5: row.stocks5,
        stocks6: row.stocks6,
        total4: row.total4,
        total5: row.total5,
        total6: row.total6,
        total14: row.total14,
        average: row.average,
        adjustedaverage: row.adjustedaverage,
        note: row.note,
        membertype: row.membertype
      });

      this.axios({
        method: "post",
        url: "/printPensionAccount",
        data: postData
      })
        .then(response => {
          console.log(this.tabledata);

          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },

  update() {
    this.axios
      .post("/listpensionaccount")
      .then(response => {
        this.tabledata = response.data;
        console.log(this.tabledata);
      })
      .catch(error => {
        console.log(error);
      });
  },
  created() {
    this.axios
      .post("/listpensionaccount")
      .then(response => {
        this.tabledata = response.data;
      })
      .catch(error => {
        this.show = false;
        this.$message({ type: 'error', message: '開発中です。' });
        console.log(error);
      });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/PensionAdmin.vue